import p5 from 'p5';
import { Link } from 'react-router-dom';
import React, { useRef, useEffect, useState } from 'react';
import '../styles/landing.css'

function LandingPage (props) {
  const [openClass, setClass] = useState('');
  const myRef = useRef();
  let Sketch;
  let myP5;
  Sketch = (p) => {

    const particles = []
    let inRange = []
    let button;
    let header;
    let body;
    let keepOpen = false;
    let endCheck = false;
    let restart = false;

    p.setup = () => {
      p.createCanvas(window.innerWidth, window.innerHeight);
      const particlesLength = Math.floor(window.innerWidth / 7);

      button = p.select('#button')
      button.mousePressed(end)
      header = p.select('header')

      body = p.select('.dark-background')
      if (props.landing === 2) {
        console.log('restart')
        restart = true;
        body.removeClass('dark-background2')
        setTimeout(() => {
          body.addClass('dark-background2')
        }, 800);
      } else {
        body.addClass('dark-background2')
      }
      for (let i = 0; i < particlesLength; i++) {
        particles.push(new Particle(restart));
      }
    }
    const end = () => {
      console.log('end')
      particles.forEach((particle, index) => {
        particle.flyOut();
      })
      endCheck = true;
      setTimeout(() => {
        button.addClass('nodisplay')
        body.removeClass('dark-background2')
        header.removeClass('notransition')
        header.addClass('transition')
        keepOpen = true;
        header.addClass('open')

      }, 1200);
      setTimeout(() => {
        p.noLoop();
        props.setLanding(0)
      }, 1900);
    }

    p.draw = () => {
      if (header.hasClass("open") && !keepOpen) {
        header.removeClass('notransition')
        header.addClass('transition')
        header.removeClass('open')
      }
      p.clear()
      inRange = [];
      particles.forEach((particle, index) => {
        // if(index===1){console.log(particle.pos.x,particle.pos.y)}
        particle.updatePosition();
        particle.draw();
      })
      inRange.forEach((particle, index) => {
        particle.checkParticles(inRange.slice(index));
      })
    }

    class Particle {
      constructor(restart) {
        this.pos = p.createVector(p.random(p.width), p.random(p.height));
        this.size = 3;
        this.color = p.color(p.random(255), p.random(255), p.random(255), 255)
        if (restart) {
          this.restart = restart;
          this.count = p.width / 20
          this.save = this.pos.copy()
          let origin = p.createVector(p.width / 2, p.height / 2)
          origin.sub(this.pos)
          origin.setMag(-p.width)
          this.pos = this.pos.add(origin)
          origin.setMag(-20)
          this.vel = origin
        } else {
          this.vel = p.createVector(p.random(-0.3, 0.3), p.random(-0.3, 0.3))
        }

      }

      updatePosition () {
        this.pos.add(this.vel);
        if (this.restart) {
          this.count--;
          if (this.count < 0) {
            this.restart = false;
            this.vel = p.createVector(p.random(-0.3, 0.3), p.random(-0.3, 0.3))
          }
        } else {
          if (!endCheck) {
            this.edges();
            const d = p.dist(this.pos.x, this.pos.y, p.mouseX, p.mouseY)
            if (d < 120 && d > 50) {
              inRange.push(this)
            }
          }

        }
      }

      draw () {
        p.noStroke();
        p.fill(this.color);
        p.circle(this.pos.x, this.pos.y, this.size);
      }

      edges () {
        if (this.pos.x < 0 || this.pos.x > p.width) {
          this.vel.x *= -1;
        }
        if (this.pos.y < 0 || this.pos.y > p.height) {
          this.vel.y *= -1;
        }
      }

      checkParticles (particles) {
        particles.forEach(particle => {
          p.line(this.pos.x, this.pos.y, particle.pos.x, particle.pos.y)
          p.stroke(this.color);
          // p.stroke('rgba(255, 255, 255, 0.5)');
        })
      }
      flyOut () {
        let origin = p.createVector(p.width / 2, p.height / 2)
        origin.sub(this.pos)
        origin.setMag(20)
        this.vel = origin
      }
    }
  }
  useEffect(() => {
    myP5 = new p5(Sketch, myRef.current)
  }, [])

  useEffect(() => {
    if (props.landing === 2) {
      setClass("open")
      myP5 = new p5(Sketch, myRef.current)
    }
  }, [props.landing])

  const title = (
    <div className="home-info-container">
      <h1>David Beale</h1>
      <div className="home-title">Full Stack Developer</div>
      <div className="home-items">Javascript | HTML | CSS | NodeJS | React | Express | MongoDB | GraphQL </div>
    </div>
  )

  return (
    <div>
      {props.landing > 0 &&
        <div className="dark-background">
          <header className={"notransition " + openClass}>
            <div className="triangle top">
              {title}
            </div>
            <div className="triangle bottom">
              {title}
            </div>
            <div className="triangle left">
              {title}
            </div>
            <div className="triangle right">
              {title}
            </div>
          </header>
          <Link
            to="/projects"
          >
            <button id="button" className="main-button">View my projects</button>
          </Link>
          <div ref={myRef}></div>
        </div>
      }

    </div>
  )

}


export default LandingPage;